export class BusinessException extends Error {
  constructor (code, message) {
    super(message)
    this.code = code
    console.error(this)
  }
}

export class TechnicalException extends Error {
  constructor (message, innerException) {
    super(message)
    this.innerException = innerException
    console.error(this)
  }
}
